import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            十二大内容品类，总有一款适合你。点击分类发现更多精彩视频。
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
              accent: 'bg-accent-100 text-accent-900 hover:bg-accent-200',
              secondary: 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200',
            };
            const iconBgMap: Record<string, string> = {
              primary: 'bg-primary-500',
              accent: 'bg-accent-500',
              secondary: 'bg-secondary-500',
            };
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex flex-col items-center gap-2 p-4 rounded-xl transition-all cursor-pointer ${colorMap[cat.color] || colorMap.primary}`}
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${iconBgMap[cat.color] || iconBgMap.primary} flex items-center justify-center`}>
                  <i className={`${cat.icon} text-background-50 text-lg md:text-xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium whitespace-nowrap">{cat.name}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}